import { TObjectShareResponse } from "../../../../../services/api/instances/storageApi/types/service_types";
import { UsersAutocomplete } from "../UsersAutocomplete";
import { PermissionsBlock } from "../PermissionsBlock";
import { TPermissionAction } from "../types";
import styles from "./styles.module.css";

interface Props {
  permissions: TObjectShareResponse;
  handleChangeFields: (
    event: string | string[] | Date | null,
    type: TPermissionAction,
    id: string,
  ) => void;
  handleRevokeAccess: (id: number) => void;
  handleDeleteAccessBlock: (id: number) => void;
  hasDeleteBlockButton?: boolean;
}

export const ShareObjectForm = ({
  permissions,
  handleChangeFields,
  handleRevokeAccess,
  handleDeleteAccessBlock,
  hasDeleteBlockButton,
}: Props) => {
  return (
    <div className={styles["form-container"]}>
      <UsersAutocomplete
        permission={permissions}
        handleRevokeAccess={handleRevokeAccess}
        handleDeleteBlock={handleDeleteAccessBlock}
        handleChangeFields={handleChangeFields}
        hasDeleteBlockButton={hasDeleteBlockButton}
      />
      <PermissionsBlock
        permissions={permissions}
        handleChangeFields={handleChangeFields}
      />
    </div>
  );
};
